// Shared geo helpers: straight-line distance + rough travel-time estimate.
// Speeds are conservative city-travel averages, not routed directions —
// always presented to the user as an approximation ("約").

export function haversineKm(a, b) {
  const R = 6371, toRad = x => x * Math.PI / 180;
  const aLat = a.lat, aLon = a.lng ?? a.lon;
  const bLat = b.lat, bLon = b.lng ?? b.lon;
  const dLat = toRad(bLat - aLat), dLon = toRad(bLon - aLon);
  const x = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(aLat)) * Math.cos(toRad(bLat)) * Math.sin(dLon / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x));
}

const MODE_SPEED_KMH = { walk: 4.5, transit: 20, drive: 25 };
const MODE_LABEL = {
  walk: { zh: '步行', en: 'walk' },
  transit: { zh: '大眾運輸', en: 'transit' },
  drive: { zh: '開車', en: 'drive' },
};

// Picks a sensible mode based on distance when the caller doesn't specify one.
export function pickTravelMode(distanceKm) {
  if (distanceKm <= 1.2) return 'walk';
  if (distanceKm <= 15) return 'transit';
  return 'drive';
}

export function estimateTravelTime(distanceKm, mode, lang = 'zh') {
  const m = mode || pickTravelMode(distanceKm);
  const speed = MODE_SPEED_KMH[m] || MODE_SPEED_KMH.transit;
  const minutes = Math.max(1, Math.round((distanceKm / speed) * 60));
  const label = (MODE_LABEL[m] || MODE_LABEL.transit)[lang === 'zh' ? 'zh' : 'en'];
  return lang === 'zh' ? `約 ${minutes} 分鐘${label}` : `~${minutes} min ${label}`;
}

export function estimateTravelBetween(a, b, mode, lang = 'zh') {
  if (!a || !b || a.lat == null || b.lat == null) return null;
  const dist = haversineKm(a, b);
  return estimateTravelTime(dist, mode, lang);
}
